import React from 'react';
import removeMd from 'remove-markdown';
import { graphql } from 'gatsby';
import { Layout, routes, pageTypes, siteName, AdVideo, AdLeaderboard } from 'gatsby-theme-apollo';
import Footer from './footer';
import GameContent from './content';
import MarkDownContent from '../posts/markdown-content';
import Section from '../layout/section';
import CTA from '../cta';
import { ContentBox } from '../layout/content-box';
import { ResponsiveImage, HeaderImage } from '../media/responsive-image';
import ShareBar from '../social/share-bar';
import ContentFeed from '../feeds/content-feed';
import { MainColumn, TwoColumn, SecondaryColumn } from '../layout/columns';
import ByLine from '../content/by-line';

const Patch = ({ location, data, pageContext }) => {
  const pageType = pageTypes.PATCH;
  const { cms } = data;
  const { patch } = cms;
  const { relatedFeed } = pageContext;
  const { id, version, description, createdAt, game, heroImage } = patch;
  const gameName = game && game.name;

  const pageTitle = `${version} | ${gameName} Patch Notes | ${siteName}`;
  const descriptionSEO = removeMd(description, { stripListLeaders: false });

  const crumbs = [
    { text: `${gameName} Wiki`, url: routes.GameHub(gameName), hide: true },
    { text: `Patch Notes`, url: routes.PatchHub(gameName) }
  ];

  const showBottomShareBar = description && description.length > 1000;

  const headline = `${game.name} Patch Notes ${version}`;

  const pageStructuredData = {
    '@type': `NewsArticle`,
    headline,
    datePublished: createdAt,
    image: heroImage && [heroImage.url],
    author: {
      '@type': 'Organization',
      name: siteName
    }
  };

  return (
    <Layout
      location={location}
      title={pageTitle}
      description={descriptionSEO}
      pageType={pageType}
      gameName={gameName}
      pageStructuredData={pageStructuredData}
    >
      <ResponsiveImage>{heroImage && <HeaderImage src={heroImage.url} />}</ResponsiveImage>
      <GameContent header={headline} headerTextSize={`42px`} pop noHeader crumbs={crumbs}>
        <TwoColumn>
          <MainColumn>
            <Section solidBackground>
              <ByLine date={createdAt} />
              <ShareBar location="top" />
              <AdLeaderboard placementId={"gh-leaderboard-" + pageType + "-mid"} />
              <ContentBox>
                <MarkDownContent md={description} />
              </ContentBox>
            </Section>
            <Section solidBackground>
              <ContentBox>
                {showBottomShareBar && <ShareBar location="bottom" />}
                <CTA campaignKey="MakeTierList" providedCampaignData={{ patchVersion: version }} />
              </ContentBox>
            </Section>
          </MainColumn>
          <SecondaryColumn>
            <Section solidBackground>
              <ContentFeed feed={relatedFeed} pageContentID={id} />
              <AdVideo placementId={'gh-video-' + pageType + '-floating'} />
            </Section>
          </SecondaryColumn>
        </TwoColumn>
      </GameContent>
      <Footer />
    </Layout>
  );
};

export const pageQuery = graphql`
  query($patchID: ID!) {
    cms {
      patch(id: $patchID) {
        version
        createdAt
        description
        heroImage {
          url
        }
        game {
          name
        }
      }
    }
  }
`;

export default Patch;
